// Guardian AI Commission & Payout Service Protocol Definitions
// Commission configuration, distribution tracking, and Stripe Connect payouts
//
// Version: v1
// Purpose: High-Trust Cybersecurity Marketplace - Financial operations

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/payment/commission.proto (package guardianai.v1.payment, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/payment/commission.proto.
 */
export const file_guardianai_v1_payment_commission: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * No params - returns global config
 *
 * @generated from message guardianai.v1.payment.GetCommissionConfigRequest
 */
export type GetCommissionConfigRequest = Message<"guardianai.v1.payment.GetCommissionConfigRequest"> & {
};

/**
 * No params - returns global config
 *
 * @generated from message guardianai.v1.payment.GetCommissionConfigRequest
 */
export type GetCommissionConfigRequestJson = {
};

/**
 * Describes the message guardianai.v1.payment.GetCommissionConfigRequest.
 * Use `create(GetCommissionConfigRequestSchema)` to create a new message.
 */
export const GetCommissionConfigRequestSchema: GenMessage<GetCommissionConfigRequest, {jsonType: GetCommissionConfigRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 0);

/**
 * @generated from message guardianai.v1.payment.CommissionConfigResponse
 */
export type CommissionConfigResponse = Message<"guardianai.v1.payment.CommissionConfigResponse"> & {
  /**
   * e.g., 0.15 = 15%
   *
   * @generated from field: double platform_commission_rate = 1;
   */
  platformCommissionRate: number;

  /**
   * e.g., 0.05 = 5%
   *
   * @generated from field: double default_hr_commission_rate = 2;
   */
  defaultHrCommissionRate: number;

  /**
   * e.g., 5000 = $50 minimum
   *
   * @generated from field: int64 minimum_payout_cents = 3;
   */
  minimumPayoutCents: bigint;

  /**
   * e.g., 14 = bi-weekly
   *
   * @generated from field: int32 payout_schedule_days = 4;
   */
  payoutScheduleDays: number;

  /**
   * @generated from field: int64 updated_at = 5;
   */
  updatedAt: bigint;

  /**
   * @generated from field: string updated_by = 6;
   */
  updatedBy: string;
};

/**
 * @generated from message guardianai.v1.payment.CommissionConfigResponse
 */
export type CommissionConfigResponseJson = {
  /**
   * e.g., 0.15 = 15%
   *
   * @generated from field: double platform_commission_rate = 1;
   */
  platformCommissionRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * e.g., 0.05 = 5%
   *
   * @generated from field: double default_hr_commission_rate = 2;
   */
  defaultHrCommissionRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * e.g., 5000 = $50 minimum
   *
   * @generated from field: int64 minimum_payout_cents = 3;
   */
  minimumPayoutCents?: string;

  /**
   * e.g., 14 = bi-weekly
   *
   * @generated from field: int32 payout_schedule_days = 4;
   */
  payoutScheduleDays?: number;

  /**
   * @generated from field: int64 updated_at = 5;
   */
  updatedAt?: string;

  /**
   * @generated from field: string updated_by = 6;
   */
  updatedBy?: string;
};

/**
 * Describes the message guardianai.v1.payment.CommissionConfigResponse.
 * Use `create(CommissionConfigResponseSchema)` to create a new message.
 */
export const CommissionConfigResponseSchema: GenMessage<CommissionConfigResponse, {jsonType: CommissionConfigResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 1);

/**
 * @generated from message guardianai.v1.payment.UpdatePlatformCommissionRequest
 */
export type UpdatePlatformCommissionRequest = Message<"guardianai.v1.payment.UpdatePlatformCommissionRequest"> & {
  /**
   * @generated from field: double new_rate = 1;
   */
  newRate: number;

  /**
   * @generated from field: string admin_user_id = 2;
   */
  adminUserId: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.payment.UpdatePlatformCommissionRequest
 */
export type UpdatePlatformCommissionRequestJson = {
  /**
   * @generated from field: double new_rate = 1;
   */
  newRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string admin_user_id = 2;
   */
  adminUserId?: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.payment.UpdatePlatformCommissionRequest.
 * Use `create(UpdatePlatformCommissionRequestSchema)` to create a new message.
 */
export const UpdatePlatformCommissionRequestSchema: GenMessage<UpdatePlatformCommissionRequest, {jsonType: UpdatePlatformCommissionRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 2);

/**
 * @generated from message guardianai.v1.payment.UpdateDefaultHrCommissionRequest
 */
export type UpdateDefaultHrCommissionRequest = Message<"guardianai.v1.payment.UpdateDefaultHrCommissionRequest"> & {
  /**
   * @generated from field: double new_rate = 1;
   */
  newRate: number;

  /**
   * @generated from field: string admin_user_id = 2;
   */
  adminUserId: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.payment.UpdateDefaultHrCommissionRequest
 */
export type UpdateDefaultHrCommissionRequestJson = {
  /**
   * @generated from field: double new_rate = 1;
   */
  newRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string admin_user_id = 2;
   */
  adminUserId?: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.payment.UpdateDefaultHrCommissionRequest.
 * Use `create(UpdateDefaultHrCommissionRequestSchema)` to create a new message.
 */
export const UpdateDefaultHrCommissionRequestSchema: GenMessage<UpdateDefaultHrCommissionRequest, {jsonType: UpdateDefaultHrCommissionRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 3);

/**
 * @generated from message guardianai.v1.payment.GetCommissionHistoryRequest
 */
export type GetCommissionHistoryRequest = Message<"guardianai.v1.payment.GetCommissionHistoryRequest"> & {
  /**
   * @generated from field: int32 limit = 1;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.payment.GetCommissionHistoryRequest
 */
export type GetCommissionHistoryRequestJson = {
  /**
   * @generated from field: int32 limit = 1;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.payment.GetCommissionHistoryRequest.
 * Use `create(GetCommissionHistoryRequestSchema)` to create a new message.
 */
export const GetCommissionHistoryRequestSchema: GenMessage<GetCommissionHistoryRequest, {jsonType: GetCommissionHistoryRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 4);

/**
 * @generated from message guardianai.v1.payment.CommissionHistoryResponse
 */
export type CommissionHistoryResponse = Message<"guardianai.v1.payment.CommissionHistoryResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.payment.CommissionChangeEvent events = 1;
   */
  events: CommissionChangeEvent[];
};

/**
 * @generated from message guardianai.v1.payment.CommissionHistoryResponse
 */
export type CommissionHistoryResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.payment.CommissionChangeEvent events = 1;
   */
  events?: CommissionChangeEventJson[];
};

/**
 * Describes the message guardianai.v1.payment.CommissionHistoryResponse.
 * Use `create(CommissionHistoryResponseSchema)` to create a new message.
 */
export const CommissionHistoryResponseSchema: GenMessage<CommissionHistoryResponse, {jsonType: CommissionHistoryResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 5);

/**
 * @generated from message guardianai.v1.payment.CommissionChangeEvent
 */
export type CommissionChangeEvent = Message<"guardianai.v1.payment.CommissionChangeEvent"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * platform_rate, hr_rate, min_payout
   *
   * @generated from field: string field_changed = 2;
   */
  fieldChanged: string;

  /**
   * @generated from field: string old_value = 3;
   */
  oldValue: string;

  /**
   * @generated from field: string new_value = 4;
   */
  newValue: string;

  /**
   * @generated from field: string changed_by = 5;
   */
  changedBy: string;

  /**
   * @generated from field: string reason = 6;
   */
  reason: string;

  /**
   * @generated from field: int64 changed_at = 7;
   */
  changedAt: bigint;
};

/**
 * @generated from message guardianai.v1.payment.CommissionChangeEvent
 */
export type CommissionChangeEventJson = {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId?: string;

  /**
   * platform_rate, hr_rate, min_payout
   *
   * @generated from field: string field_changed = 2;
   */
  fieldChanged?: string;

  /**
   * @generated from field: string old_value = 3;
   */
  oldValue?: string;

  /**
   * @generated from field: string new_value = 4;
   */
  newValue?: string;

  /**
   * @generated from field: string changed_by = 5;
   */
  changedBy?: string;

  /**
   * @generated from field: string reason = 6;
   */
  reason?: string;

  /**
   * @generated from field: int64 changed_at = 7;
   */
  changedAt?: string;
};

/**
 * Describes the message guardianai.v1.payment.CommissionChangeEvent.
 * Use `create(CommissionChangeEventSchema)` to create a new message.
 */
export const CommissionChangeEventSchema: GenMessage<CommissionChangeEvent, {jsonType: CommissionChangeEventJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 6);

/**
 * @generated from message guardianai.v1.payment.InitiateStripeConnectRequest
 */
export type InitiateStripeConnectRequest = Message<"guardianai.v1.payment.InitiateStripeConnectRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * HR_MANAGER or CYBERSECURITY_EXPERT
   *
   * @generated from field: string user_role = 2;
   */
  userRole: string;

  /**
   * @generated from field: string redirect_url = 3;
   */
  redirectUrl: string;
};

/**
 * @generated from message guardianai.v1.payment.InitiateStripeConnectRequest
 */
export type InitiateStripeConnectRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * HR_MANAGER or CYBERSECURITY_EXPERT
   *
   * @generated from field: string user_role = 2;
   */
  userRole?: string;

  /**
   * @generated from field: string redirect_url = 3;
   */
  redirectUrl?: string;
};

/**
 * Describes the message guardianai.v1.payment.InitiateStripeConnectRequest.
 * Use `create(InitiateStripeConnectRequestSchema)` to create a new message.
 */
export const InitiateStripeConnectRequestSchema: GenMessage<InitiateStripeConnectRequest, {jsonType: InitiateStripeConnectRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 7);

/**
 * @generated from message guardianai.v1.payment.InitiateStripeConnectResponse
 */
export type InitiateStripeConnectResponse = Message<"guardianai.v1.payment.InitiateStripeConnectResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * Redirect user here
   *
   * @generated from field: string oauth_url = 3;
   */
  oauthUrl: string;

  /**
   * CSRF protection
   *
   * @generated from field: string state_token = 4;
   */
  stateToken: string;
};

/**
 * @generated from message guardianai.v1.payment.InitiateStripeConnectResponse
 */
export type InitiateStripeConnectResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * Redirect user here
   *
   * @generated from field: string oauth_url = 3;
   */
  oauthUrl?: string;

  /**
   * CSRF protection
   *
   * @generated from field: string state_token = 4;
   */
  stateToken?: string;
};

/**
 * Describes the message guardianai.v1.payment.InitiateStripeConnectResponse.
 * Use `create(InitiateStripeConnectResponseSchema)` to create a new message.
 */
export const InitiateStripeConnectResponseSchema: GenMessage<InitiateStripeConnectResponse, {jsonType: InitiateStripeConnectResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 8);

/**
 * @generated from message guardianai.v1.payment.CompleteStripeConnectRequest
 */
export type CompleteStripeConnectRequest = Message<"guardianai.v1.payment.CompleteStripeConnectRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string authorization_code = 2;
   */
  authorizationCode: string;

  /**
   * @generated from field: string state_token = 3;
   */
  stateToken: string;
};

/**
 * @generated from message guardianai.v1.payment.CompleteStripeConnectRequest
 */
export type CompleteStripeConnectRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string authorization_code = 2;
   */
  authorizationCode?: string;

  /**
   * @generated from field: string state_token = 3;
   */
  stateToken?: string;
};

/**
 * Describes the message guardianai.v1.payment.CompleteStripeConnectRequest.
 * Use `create(CompleteStripeConnectRequestSchema)` to create a new message.
 */
export const CompleteStripeConnectRequestSchema: GenMessage<CompleteStripeConnectRequest, {jsonType: CompleteStripeConnectRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 9);

/**
 * @generated from message guardianai.v1.payment.CompleteStripeConnectResponse
 */
export type CompleteStripeConnectResponse = Message<"guardianai.v1.payment.CompleteStripeConnectResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: string stripe_account_id = 3;
   */
  stripeAccountId: string;

  /**
   * @generated from field: bool charges_enabled = 4;
   */
  chargesEnabled: boolean;

  /**
   * @generated from field: bool payouts_enabled = 5;
   */
  payoutsEnabled: boolean;
};

/**
 * @generated from message guardianai.v1.payment.CompleteStripeConnectResponse
 */
export type CompleteStripeConnectResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: string stripe_account_id = 3;
   */
  stripeAccountId?: string;

  /**
   * @generated from field: bool charges_enabled = 4;
   */
  chargesEnabled?: boolean;

  /**
   * @generated from field: bool payouts_enabled = 5;
   */
  payoutsEnabled?: boolean;
};

/**
 * Describes the message guardianai.v1.payment.CompleteStripeConnectResponse.
 * Use `create(CompleteStripeConnectResponseSchema)` to create a new message.
 */
export const CompleteStripeConnectResponseSchema: GenMessage<CompleteStripeConnectResponse, {jsonType: CompleteStripeConnectResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 10);

/**
 * @generated from message guardianai.v1.payment.GetStripeAccountStatusRequest
 */
export type GetStripeAccountStatusRequest = Message<"guardianai.v1.payment.GetStripeAccountStatusRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.payment.GetStripeAccountStatusRequest
 */
export type GetStripeAccountStatusRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.payment.GetStripeAccountStatusRequest.
 * Use `create(GetStripeAccountStatusRequestSchema)` to create a new message.
 */
export const GetStripeAccountStatusRequestSchema: GenMessage<GetStripeAccountStatusRequest, {jsonType: GetStripeAccountStatusRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 11);

/**
 * @generated from message guardianai.v1.payment.StripeAccountStatusResponse
 */
export type StripeAccountStatusResponse = Message<"guardianai.v1.payment.StripeAccountStatusResponse"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: bool has_stripe_account = 2;
   */
  hasStripeAccount: boolean;

  /**
   * @generated from field: string stripe_account_id = 3;
   */
  stripeAccountId: string;

  /**
   * @generated from field: bool charges_enabled = 4;
   */
  chargesEnabled: boolean;

  /**
   * @generated from field: bool payouts_enabled = 5;
   */
  payoutsEnabled: boolean;

  /**
   * @generated from field: bool details_submitted = 6;
   */
  detailsSubmitted: boolean;

  /**
   * @generated from field: repeated string pending_requirements = 7;
   */
  pendingRequirements: string[];

  /**
   * @generated from field: int64 connected_at = 8;
   */
  connectedAt: bigint;
};

/**
 * @generated from message guardianai.v1.payment.StripeAccountStatusResponse
 */
export type StripeAccountStatusResponseJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: bool has_stripe_account = 2;
   */
  hasStripeAccount?: boolean;

  /**
   * @generated from field: string stripe_account_id = 3;
   */
  stripeAccountId?: string;

  /**
   * @generated from field: bool charges_enabled = 4;
   */
  chargesEnabled?: boolean;

  /**
   * @generated from field: bool payouts_enabled = 5;
   */
  payoutsEnabled?: boolean;

  /**
   * @generated from field: bool details_submitted = 6;
   */
  detailsSubmitted?: boolean;

  /**
   * @generated from field: repeated string pending_requirements = 7;
   */
  pendingRequirements?: string[];

  /**
   * @generated from field: int64 connected_at = 8;
   */
  connectedAt?: string;
};

/**
 * Describes the message guardianai.v1.payment.StripeAccountStatusResponse.
 * Use `create(StripeAccountStatusResponseSchema)` to create a new message.
 */
export const StripeAccountStatusResponseSchema: GenMessage<StripeAccountStatusResponse, {jsonType: StripeAccountStatusResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 12);

/**
 * @generated from message guardianai.v1.payment.RequestPayoutRequest
 */
export type RequestPayoutRequest = Message<"guardianai.v1.payment.RequestPayoutRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * 0 = payout full available balance
   *
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents: bigint;

  /**
   * USD default
   *
   * @generated from field: string currency = 3;
   */
  currency: string;
};

/**
 * @generated from message guardianai.v1.payment.RequestPayoutRequest
 */
export type RequestPayoutRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * 0 = payout full available balance
   *
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents?: string;

  /**
   * USD default
   *
   * @generated from field: string currency = 3;
   */
  currency?: string;
};

/**
 * Describes the message guardianai.v1.payment.RequestPayoutRequest.
 * Use `create(RequestPayoutRequestSchema)` to create a new message.
 */
export const RequestPayoutRequestSchema: GenMessage<RequestPayoutRequest, {jsonType: RequestPayoutRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 13);

/**
 * @generated from message guardianai.v1.payment.RequestPayoutResponse
 */
export type RequestPayoutResponse = Message<"guardianai.v1.payment.RequestPayoutResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: string payout_id = 3;
   */
  payoutId: string;

  /**
   * @generated from field: int64 amount_cents = 4;
   */
  amountCents: bigint;

  /**
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * BELOW_MINIMUM, NO_STRIPE_ACCOUNT, INSUFFICIENT_BALANCE
   *
   * @generated from field: string error_code = 6;
   */
  errorCode: string;
};

/**
 * @generated from message guardianai.v1.payment.RequestPayoutResponse
 */
export type RequestPayoutResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: string payout_id = 3;
   */
  payoutId?: string;

  /**
   * @generated from field: int64 amount_cents = 4;
   */
  amountCents?: string;

  /**
   * @generated from field: string status = 5;
   */
  status?: string;

  /**
   * BELOW_MINIMUM, NO_STRIPE_ACCOUNT, INSUFFICIENT_BALANCE
   *
   * @generated from field: string error_code = 6;
   */
  errorCode?: string;
};

/**
 * Describes the message guardianai.v1.payment.RequestPayoutResponse.
 * Use `create(RequestPayoutResponseSchema)` to create a new message.
 */
export const RequestPayoutResponseSchema: GenMessage<RequestPayoutResponse, {jsonType: RequestPayoutResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 14);

/**
 * @generated from message guardianai.v1.payment.GetPayoutStatusRequest
 */
export type GetPayoutStatusRequest = Message<"guardianai.v1.payment.GetPayoutStatusRequest"> & {
  /**
   * @generated from field: string payout_id = 1;
   */
  payoutId: string;
};

/**
 * @generated from message guardianai.v1.payment.GetPayoutStatusRequest
 */
export type GetPayoutStatusRequestJson = {
  /**
   * @generated from field: string payout_id = 1;
   */
  payoutId?: string;
};

/**
 * Describes the message guardianai.v1.payment.GetPayoutStatusRequest.
 * Use `create(GetPayoutStatusRequestSchema)` to create a new message.
 */
export const GetPayoutStatusRequestSchema: GenMessage<GetPayoutStatusRequest, {jsonType: GetPayoutStatusRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 15);

/**
 * @generated from message guardianai.v1.payment.PayoutStatusResponse
 */
export type PayoutStatusResponse = Message<"guardianai.v1.payment.PayoutStatusResponse"> & {
  /**
   * @generated from field: string payout_id = 1;
   */
  payoutId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: int64 amount_cents = 3;
   */
  amountCents: bigint;

  /**
   * @generated from field: string currency = 4;
   */
  currency: string;

  /**
   * PENDING, PROCESSING, PAID, FAILED, CANCELLED
   *
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: string stripe_payout_id = 6;
   */
  stripePayoutId: string;

  /**
   * @generated from field: int64 requested_at = 7;
   */
  requestedAt: bigint;

  /**
   * @generated from field: int64 processed_at = 8;
   */
  processedAt: bigint;

  /**
   * @generated from field: int64 paid_at = 9;
   */
  paidAt: bigint;

  /**
   * @generated from field: string failure_reason = 10;
   */
  failureReason: string;
};

/**
 * @generated from message guardianai.v1.payment.PayoutStatusResponse
 */
export type PayoutStatusResponseJson = {
  /**
   * @generated from field: string payout_id = 1;
   */
  payoutId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: int64 amount_cents = 3;
   */
  amountCents?: string;

  /**
   * @generated from field: string currency = 4;
   */
  currency?: string;

  /**
   * PENDING, PROCESSING, PAID, FAILED, CANCELLED
   *
   * @generated from field: string status = 5;
   */
  status?: string;

  /**
   * @generated from field: string stripe_payout_id = 6;
   */
  stripePayoutId?: string;

  /**
   * @generated from field: int64 requested_at = 7;
   */
  requestedAt?: string;

  /**
   * @generated from field: int64 processed_at = 8;
   */
  processedAt?: string;

  /**
   * @generated from field: int64 paid_at = 9;
   */
  paidAt?: string;

  /**
   * @generated from field: string failure_reason = 10;
   */
  failureReason?: string;
};

/**
 * Describes the message guardianai.v1.payment.PayoutStatusResponse.
 * Use `create(PayoutStatusResponseSchema)` to create a new message.
 */
export const PayoutStatusResponseSchema: GenMessage<PayoutStatusResponse, {jsonType: PayoutStatusResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 16);

/**
 * @generated from message guardianai.v1.payment.ListPayoutsRequest
 */
export type ListPayoutsRequest = Message<"guardianai.v1.payment.ListPayoutsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string status_filter = 2;
   */
  statusFilter: string;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.payment.ListPayoutsRequest
 */
export type ListPayoutsRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string status_filter = 2;
   */
  statusFilter?: string;

  /**
   * @generated from field: int32 page = 3;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.payment.ListPayoutsRequest.
 * Use `create(ListPayoutsRequestSchema)` to create a new message.
 */
export const ListPayoutsRequestSchema: GenMessage<ListPayoutsRequest, {jsonType: ListPayoutsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 17);

/**
 * @generated from message guardianai.v1.payment.ListPayoutsResponse
 */
export type ListPayoutsResponse = Message<"guardianai.v1.payment.ListPayoutsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.payment.PayoutStatusResponse payouts = 1;
   */
  payouts: PayoutStatusResponse[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.payment.ListPayoutsResponse
 */
export type ListPayoutsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.payment.PayoutStatusResponse payouts = 1;
   */
  payouts?: PayoutStatusResponseJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;

  /**
   * @generated from field: int32 page = 3;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.payment.ListPayoutsResponse.
 * Use `create(ListPayoutsResponseSchema)` to create a new message.
 */
export const ListPayoutsResponseSchema: GenMessage<ListPayoutsResponse, {jsonType: ListPayoutsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 18);

/**
 * @generated from message guardianai.v1.payment.GetEarningsSummaryRequest
 */
export type GetEarningsSummaryRequest = Message<"guardianai.v1.payment.GetEarningsSummaryRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.payment.GetEarningsSummaryRequest
 */
export type GetEarningsSummaryRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.payment.GetEarningsSummaryRequest.
 * Use `create(GetEarningsSummaryRequestSchema)` to create a new message.
 */
export const GetEarningsSummaryRequestSchema: GenMessage<GetEarningsSummaryRequest, {jsonType: GetEarningsSummaryRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 19);

/**
 * @generated from message guardianai.v1.payment.EarningsSummaryResponse
 */
export type EarningsSummaryResponse = Message<"guardianai.v1.payment.EarningsSummaryResponse"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int64 total_earned_cents = 2;
   */
  totalEarnedCents: bigint;

  /**
   * @generated from field: int64 total_withdrawn_cents = 3;
   */
  totalWithdrawnCents: bigint;

  /**
   * @generated from field: int64 available_balance_cents = 4;
   */
  availableBalanceCents: bigint;

  /**
   * In escrow/processing
   *
   * @generated from field: int64 pending_balance_cents = 5;
   */
  pendingBalanceCents: bigint;

  /**
   * @generated from field: int64 period_start = 6;
   */
  periodStart: bigint;

  /**
   * @generated from field: int64 period_end = 7;
   */
  periodEnd: bigint;
};

/**
 * @generated from message guardianai.v1.payment.EarningsSummaryResponse
 */
export type EarningsSummaryResponseJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int64 total_earned_cents = 2;
   */
  totalEarnedCents?: string;

  /**
   * @generated from field: int64 total_withdrawn_cents = 3;
   */
  totalWithdrawnCents?: string;

  /**
   * @generated from field: int64 available_balance_cents = 4;
   */
  availableBalanceCents?: string;

  /**
   * In escrow/processing
   *
   * @generated from field: int64 pending_balance_cents = 5;
   */
  pendingBalanceCents?: string;

  /**
   * @generated from field: int64 period_start = 6;
   */
  periodStart?: string;

  /**
   * @generated from field: int64 period_end = 7;
   */
  periodEnd?: string;
};

/**
 * Describes the message guardianai.v1.payment.EarningsSummaryResponse.
 * Use `create(EarningsSummaryResponseSchema)` to create a new message.
 */
export const EarningsSummaryResponseSchema: GenMessage<EarningsSummaryResponse, {jsonType: EarningsSummaryResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 20);

/**
 * @generated from message guardianai.v1.payment.GetEarningsBreakdownRequest
 */
export type GetEarningsBreakdownRequest = Message<"guardianai.v1.payment.GetEarningsBreakdownRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int64 from_date = 2;
   */
  fromDate: bigint;

  /**
   * @generated from field: int64 to_date = 3;
   */
  toDate: bigint;

  /**
   * DAY, WEEK, MONTH
   *
   * @generated from field: string group_by = 4;
   */
  groupBy: string;
};

/**
 * @generated from message guardianai.v1.payment.GetEarningsBreakdownRequest
 */
export type GetEarningsBreakdownRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int64 from_date = 2;
   */
  fromDate?: string;

  /**
   * @generated from field: int64 to_date = 3;
   */
  toDate?: string;

  /**
   * DAY, WEEK, MONTH
   *
   * @generated from field: string group_by = 4;
   */
  groupBy?: string;
};

/**
 * Describes the message guardianai.v1.payment.GetEarningsBreakdownRequest.
 * Use `create(GetEarningsBreakdownRequestSchema)` to create a new message.
 */
export const GetEarningsBreakdownRequestSchema: GenMessage<GetEarningsBreakdownRequest, {jsonType: GetEarningsBreakdownRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 21);

/**
 * @generated from message guardianai.v1.payment.EarningsBreakdownResponse
 */
export type EarningsBreakdownResponse = Message<"guardianai.v1.payment.EarningsBreakdownResponse"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: int64 gross_earnings_cents = 2;
   */
  grossEarningsCents: bigint;

  /**
   * @generated from field: int64 platform_commission_cents = 3;
   */
  platformCommissionCents: bigint;

  /**
   * Only for experts
   *
   * @generated from field: int64 hr_commission_cents = 4;
   */
  hrCommissionCents: bigint;

  /**
   * @generated from field: int64 net_earnings_cents = 5;
   */
  netEarningsCents: bigint;

  /**
   * @generated from field: repeated guardianai.v1.payment.EarningsPeriod periods = 6;
   */
  periods: EarningsPeriod[];

  /**
   * @generated from field: repeated guardianai.v1.payment.EarningsPerJob jobs = 7;
   */
  jobs: EarningsPerJob[];
};

/**
 * @generated from message guardianai.v1.payment.EarningsBreakdownResponse
 */
export type EarningsBreakdownResponseJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: int64 gross_earnings_cents = 2;
   */
  grossEarningsCents?: string;

  /**
   * @generated from field: int64 platform_commission_cents = 3;
   */
  platformCommissionCents?: string;

  /**
   * Only for experts
   *
   * @generated from field: int64 hr_commission_cents = 4;
   */
  hrCommissionCents?: string;

  /**
   * @generated from field: int64 net_earnings_cents = 5;
   */
  netEarningsCents?: string;

  /**
   * @generated from field: repeated guardianai.v1.payment.EarningsPeriod periods = 6;
   */
  periods?: EarningsPeriodJson[];

  /**
   * @generated from field: repeated guardianai.v1.payment.EarningsPerJob jobs = 7;
   */
  jobs?: EarningsPerJobJson[];
};

/**
 * Describes the message guardianai.v1.payment.EarningsBreakdownResponse.
 * Use `create(EarningsBreakdownResponseSchema)` to create a new message.
 */
export const EarningsBreakdownResponseSchema: GenMessage<EarningsBreakdownResponse, {jsonType: EarningsBreakdownResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 22);

/**
 * @generated from message guardianai.v1.payment.EarningsPeriod
 */
export type EarningsPeriod = Message<"guardianai.v1.payment.EarningsPeriod"> & {
  /**
   * "2026-01-15", "Week 3", "January 2026"
   *
   * @generated from field: string period_label = 1;
   */
  periodLabel: string;

  /**
   * @generated from field: int64 gross_cents = 2;
   */
  grossCents: bigint;

  /**
   * @generated from field: int64 net_cents = 3;
   */
  netCents: bigint;

  /**
   * @generated from field: int32 job_count = 4;
   */
  jobCount: number;
};

/**
 * @generated from message guardianai.v1.payment.EarningsPeriod
 */
export type EarningsPeriodJson = {
  /**
   * "2026-01-15", "Week 3", "January 2026"
   *
   * @generated from field: string period_label = 1;
   */
  periodLabel?: string;

  /**
   * @generated from field: int64 gross_cents = 2;
   */
  grossCents?: string;

  /**
   * @generated from field: int64 net_cents = 3;
   */
  netCents?: string;

  /**
   * @generated from field: int32 job_count = 4;
   */
  jobCount?: number;
};

/**
 * Describes the message guardianai.v1.payment.EarningsPeriod.
 * Use `create(EarningsPeriodSchema)` to create a new message.
 */
export const EarningsPeriodSchema: GenMessage<EarningsPeriod, {jsonType: EarningsPeriodJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 23);

/**
 * @generated from message guardianai.v1.payment.EarningsPerJob
 */
export type EarningsPerJob = Message<"guardianai.v1.payment.EarningsPerJob"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string job_title = 2;
   */
  jobTitle: string;

  /**
   * @generated from field: int64 gross_cents = 3;
   */
  grossCents: bigint;

  /**
   * @generated from field: int64 platform_fee_cents = 4;
   */
  platformFeeCents: bigint;

  /**
   * @generated from field: int64 hr_fee_cents = 5;
   */
  hrFeeCents: bigint;

  /**
   * @generated from field: int64 net_cents = 6;
   */
  netCents: bigint;

  /**
   * @generated from field: int64 completed_at = 7;
   */
  completedAt: bigint;
};

/**
 * @generated from message guardianai.v1.payment.EarningsPerJob
 */
export type EarningsPerJobJson = {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId?: string;

  /**
   * @generated from field: string job_title = 2;
   */
  jobTitle?: string;

  /**
   * @generated from field: int64 gross_cents = 3;
   */
  grossCents?: string;

  /**
   * @generated from field: int64 platform_fee_cents = 4;
   */
  platformFeeCents?: string;

  /**
   * @generated from field: int64 hr_fee_cents = 5;
   */
  hrFeeCents?: string;

  /**
   * @generated from field: int64 net_cents = 6;
   */
  netCents?: string;

  /**
   * @generated from field: int64 completed_at = 7;
   */
  completedAt?: string;
};

/**
 * Describes the message guardianai.v1.payment.EarningsPerJob.
 * Use `create(EarningsPerJobSchema)` to create a new message.
 */
export const EarningsPerJobSchema: GenMessage<EarningsPerJob, {jsonType: EarningsPerJobJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 24);

/**
 * @generated from message guardianai.v1.payment.ProcessPendingPayoutsRequest
 */
export type ProcessPendingPayoutsRequest = Message<"guardianai.v1.payment.ProcessPendingPayoutsRequest"> & {
  /**
   * @generated from field: string admin_user_id = 1;
   */
  adminUserId: string;

  /**
   * @generated from field: bool dry_run = 2;
   */
  dryRun: boolean;
};

/**
 * @generated from message guardianai.v1.payment.ProcessPendingPayoutsRequest
 */
export type ProcessPendingPayoutsRequestJson = {
  /**
   * @generated from field: string admin_user_id = 1;
   */
  adminUserId?: string;

  /**
   * @generated from field: bool dry_run = 2;
   */
  dryRun?: boolean;
};

/**
 * Describes the message guardianai.v1.payment.ProcessPendingPayoutsRequest.
 * Use `create(ProcessPendingPayoutsRequestSchema)` to create a new message.
 */
export const ProcessPendingPayoutsRequestSchema: GenMessage<ProcessPendingPayoutsRequest, {jsonType: ProcessPendingPayoutsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 25);

/**
 * @generated from message guardianai.v1.payment.ProcessPendingPayoutsResponse
 */
export type ProcessPendingPayoutsResponse = Message<"guardianai.v1.payment.ProcessPendingPayoutsResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: int32 payouts_processed = 2;
   */
  payoutsProcessed: number;

  /**
   * @generated from field: int64 total_amount_cents = 3;
   */
  totalAmountCents: bigint;

  /**
   * @generated from field: repeated string payout_ids = 4;
   */
  payoutIds: string[];
};

/**
 * @generated from message guardianai.v1.payment.ProcessPendingPayoutsResponse
 */
export type ProcessPendingPayoutsResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: int32 payouts_processed = 2;
   */
  payoutsProcessed?: number;

  /**
   * @generated from field: int64 total_amount_cents = 3;
   */
  totalAmountCents?: string;

  /**
   * @generated from field: repeated string payout_ids = 4;
   */
  payoutIds?: string[];
};

/**
 * Describes the message guardianai.v1.payment.ProcessPendingPayoutsResponse.
 * Use `create(ProcessPendingPayoutsResponseSchema)` to create a new message.
 */
export const ProcessPendingPayoutsResponseSchema: GenMessage<ProcessPendingPayoutsResponse, {jsonType: ProcessPendingPayoutsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 26);

/**
 * @generated from message guardianai.v1.payment.AdminPayoutOverrideRequest
 */
export type AdminPayoutOverrideRequest = Message<"guardianai.v1.payment.AdminPayoutOverrideRequest"> & {
  /**
   * @generated from field: string payout_id = 1;
   */
  payoutId: string;

  /**
   * @generated from field: string admin_user_id = 2;
   */
  adminUserId: string;

  /**
   * APPROVE, REJECT, CANCEL
   *
   * @generated from field: string action = 3;
   */
  action: string;

  /**
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.payment.AdminPayoutOverrideRequest
 */
export type AdminPayoutOverrideRequestJson = {
  /**
   * @generated from field: string payout_id = 1;
   */
  payoutId?: string;

  /**
   * @generated from field: string admin_user_id = 2;
   */
  adminUserId?: string;

  /**
   * APPROVE, REJECT, CANCEL
   *
   * @generated from field: string action = 3;
   */
  action?: string;

  /**
   * @generated from field: string reason = 4;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.payment.AdminPayoutOverrideRequest.
 * Use `create(AdminPayoutOverrideRequestSchema)` to create a new message.
 */
export const AdminPayoutOverrideRequestSchema: GenMessage<AdminPayoutOverrideRequest, {jsonType: AdminPayoutOverrideRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 27);

/**
 * @generated from message guardianai.v1.payment.AdminPayoutOverrideResponse
 */
export type AdminPayoutOverrideResponse = Message<"guardianai.v1.payment.AdminPayoutOverrideResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: guardianai.v1.payment.PayoutStatusResponse payout = 3;
   */
  payout?: PayoutStatusResponse;
};

/**
 * @generated from message guardianai.v1.payment.AdminPayoutOverrideResponse
 */
export type AdminPayoutOverrideResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;

  /**
   * @generated from field: guardianai.v1.payment.PayoutStatusResponse payout = 3;
   */
  payout?: PayoutStatusResponseJson;
};

/**
 * Describes the message guardianai.v1.payment.AdminPayoutOverrideResponse.
 * Use `create(AdminPayoutOverrideResponseSchema)` to create a new message.
 */
export const AdminPayoutOverrideResponseSchema: GenMessage<AdminPayoutOverrideResponse, {jsonType: AdminPayoutOverrideResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_payment_commission, 28);

/**
 * @generated from service guardianai.v1.payment.CommissionConfigService
 */
export const CommissionConfigService: GenService<{
  /**
   * Get current commission configuration
   *
   * @generated from rpc guardianai.v1.payment.CommissionConfigService.GetCommissionConfig
   */
  getCommissionConfig: {
    methodKind: "unary";
    input: typeof GetCommissionConfigRequestSchema;
    output: typeof CommissionConfigResponseSchema;
  },
  /**
   * Update platform commission rate (Admin only)
   *
   * @generated from rpc guardianai.v1.payment.CommissionConfigService.UpdatePlatformCommission
   */
  updatePlatformCommission: {
    methodKind: "unary";
    input: typeof UpdatePlatformCommissionRequestSchema;
    output: typeof CommissionConfigResponseSchema;
  },
  /**
   * Update default HR Manager commission rate (Admin only)
   *
   * @generated from rpc guardianai.v1.payment.CommissionConfigService.UpdateDefaultHrCommission
   */
  updateDefaultHrCommission: {
    methodKind: "unary";
    input: typeof UpdateDefaultHrCommissionRequestSchema;
    output: typeof CommissionConfigResponseSchema;
  },
  /**
   * Get commission config history
   *
   * @generated from rpc guardianai.v1.payment.CommissionConfigService.GetCommissionHistory
   */
  getCommissionHistory: {
    methodKind: "unary";
    input: typeof GetCommissionHistoryRequestSchema;
    output: typeof CommissionHistoryResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_payment_commission, 0);

/**
 * STRIPE CONNECT ONBOARDING
 *
 * @generated from service guardianai.v1.payment.PayoutService
 */
export const PayoutService: GenService<{
  /**
   * Initiate Stripe Connect OAuth flow
   *
   * @generated from rpc guardianai.v1.payment.PayoutService.InitiateStripeConnect
   */
  initiateStripeConnect: {
    methodKind: "unary";
    input: typeof InitiateStripeConnectRequestSchema;
    output: typeof InitiateStripeConnectResponseSchema;
  },
  /**
   * Complete Stripe Connect after OAuth callback
   *
   * @generated from rpc guardianai.v1.payment.PayoutService.CompleteStripeConnect
   */
  completeStripeConnect: {
    methodKind: "unary";
    input: typeof CompleteStripeConnectRequestSchema;
    output: typeof CompleteStripeConnectResponseSchema;
  },
  /**
   * Get Stripe account status
   *
   * @generated from rpc guardianai.v1.payment.PayoutService.GetStripeAccountStatus
   */
  getStripeAccountStatus: {
    methodKind: "unary";
    input: typeof GetStripeAccountStatusRequestSchema;
    output: typeof StripeAccountStatusResponseSchema;
  },
  /**
   * Request payout (manual trigger)
   *
   * @generated from rpc guardianai.v1.payment.PayoutService.RequestPayout
   */
  requestPayout: {
    methodKind: "unary";
    input: typeof RequestPayoutRequestSchema;
    output: typeof RequestPayoutResponseSchema;
  },
  /**
   * Get payout status
   *
   * @generated from rpc guardianai.v1.payment.PayoutService.GetPayoutStatus
   */
  getPayoutStatus: {
    methodKind: "unary";
    input: typeof GetPayoutStatusRequestSchema;
    output: typeof PayoutStatusResponseSchema;
  },
  /**
   * List payout history
   *
   * @generated from rpc guardianai.v1.payment.PayoutService.ListPayouts
   */
  listPayouts: {
    methodKind: "unary";
    input: typeof ListPayoutsRequestSchema;
    output: typeof ListPayoutsResponseSchema;
  },
  /**
   * Get earnings summary
   *
   * @generated from rpc guardianai.v1.payment.PayoutService.GetEarningsSummary
   */
  getEarningsSummary: {
    methodKind: "unary";
    input: typeof GetEarningsSummaryRequestSchema;
    output: typeof EarningsSummaryResponseSchema;
  },
  /**
   * Get detailed earnings breakdown
   *
   * @generated from rpc guardianai.v1.payment.PayoutService.GetEarningsBreakdown
   */
  getEarningsBreakdown: {
    methodKind: "unary";
    input: typeof GetEarningsBreakdownRequestSchema;
    output: typeof EarningsBreakdownResponseSchema;
  },
  /**
   * Process pending payouts (batch job)
   *
   * @generated from rpc guardianai.v1.payment.PayoutService.ProcessPendingPayouts
   */
  processPendingPayouts: {
    methodKind: "unary";
    input: typeof ProcessPendingPayoutsRequestSchema;
    output: typeof ProcessPendingPayoutsResponseSchema;
  },
  /**
   * Admin payout override
   *
   * @generated from rpc guardianai.v1.payment.PayoutService.AdminPayoutOverride
   */
  adminPayoutOverride: {
    methodKind: "unary";
    input: typeof AdminPayoutOverrideRequestSchema;
    output: typeof AdminPayoutOverrideResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_payment_commission, 1);

